import React, { Component } from "react";
import { Circle, InfoWindow } from "@vis.gl/react-google-maps";
import { connect } from "react-redux";
import { mapSelectedCircle, mapChangeCircle } from "../../reducers/map";

class ImCircle extends Component {
  circleRef = (c) => { this.circle = c; };

  selectInfo = () => this.props.CIRCLE_SELECTING(this.props.id);

  onChanged = () => {
    if (!this.circle) return;
    const center = this.circle.getCenter();
    const radius = this.circle.getRadius();
    this.props.CIRCLE_CHANGE({ ...this.props, radius, center: { lat: center.lat(), lng: center.lng() } });
  };

  render() {
    const id = this.props.id;
    const selected = this.props.circle_selecting === id;
    return (
      <React.Fragment>
        <Circle
          ref={this.circleRef}
          center={this.props.center}
          radius={this.props.radius}
          editable={this.props.editable}
          strokeColor="blue"
          onClick={this.selectInfo}
          onCenterChanged={this.onChanged}
          onRadiusChanged={this.onChanged}
        />
        {selected ? (
          <InfoWindow position={this.props.center}>
            <div>
              {this.props.info.logisticsPoint ? "Logistic Point : " + this.props.info.logisticsPoint : ""}
              <br />Name: <br />{this.props.info.name}
              Description: <br />{this.props.info.description}
              <br />{this.props.isGroup}
            </div>
          </InfoWindow>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({ circle_selecting: state.map.circle_selecting });
const mapActionsToProps = { CIRCLE_SELECTING: mapSelectedCircle, CIRCLE_CHANGE: mapChangeCircle };
export default connect(mapStateToProps, mapActionsToProps)(ImCircle);
